export const FIELDS = [
  'assetIdx',
  'name',
  'precision',
  'color',
  'icon',
  'symbol',
  'relatedAssetKey',
  'isPool',
] as const
